/* ExportAction.js */

"use strict";
const _ = require("lodash");
const FileName = require("@gluenetworks/steve_utilities").fileName;
const {
    convertExpressionTags,
} = require("../../../../editors/auditpolicyeditor/utils/ruleLabelMapper");

class ExportAction {
    constructor(
        logger,
        gameEditor,
        activeView,
        ConfigAuditPolicy,
        userSession,
        steveIo,
        CustomFields,
        CommandSetEntityDef,
        TagsEntityDef
    ) {
        this._logger = logger;
        this._activeView = activeView;
        this._ConfigAuditPolicyDef = ConfigAuditPolicy;
        this._activeOrgId = userSession.activeOrganization.id;
        this._fileFactory = steveIo.fileFactory;
        this._gameEditor = gameEditor;
        this._CustomFields = CustomFields;
        this._commandSetEntityDef = CommandSetEntityDef;
        this._tagsEntityDef = TagsEntityDef;
        this._tagIdToNameMap = {};
        this.run = this.run.bind(this);
        this._fileNamer = FileName;
    }

    _processRuleForUUID(objRule, rsiIdsMap, conceptItems, cmdSetValLabelMap) {
        if (objRule.commandSet && cmdSetValLabelMap[objRule.commandSet]) {
            objRule["commandSetName"] = cmdSetValLabelMap[objRule.commandSet];
        } else if (objRule.commandSet === "allConfig") {
            objRule["commandSetName"] = "All Configuration";
        } else if (objRule.commandSet === "allOperational") {
            objRule["commandSetName"] = "All Operational";
        } else {
            objRule["commandSetName"] = "";
        }
        delete objRule.commandSet;
        if (
            objRule.conceptItemId &&
            conceptItems[objRule.conceptItemId] &&
            conceptItems[objRule.conceptItemId].label
        ) {
            objRule.conceptItem = conceptItems[objRule.conceptItemId].label;
        } else if (
            objRule.commandSetResult &&
            objRule.commandSetResult.conceptItemId &&
            conceptItems[objRule.commandSetResult.conceptItemId] &&
            conceptItems[objRule.commandSetResult.conceptItemId].label
        ) {
            objRule.commandSetResult.conceptItem =
                conceptItems[objRule.commandSetResult.conceptItemId].label;
        } else if (objRule.rsiId && rsiIdsMap[objRule.rsiId] && rsiIdsMap[objRule.rsiId].label) {
            objRule.restSyncItem = rsiIdsMap[objRule.rsiId].label;
        } else if (
            objRule.commandSetResult &&
            objRule.commandSetResult.restSyncItemId &&
            rsiIdsMap[objRule.commandSetResult.restSyncItemId] &&
            rsiIdsMap[objRule.commandSetResult.restSyncItemId].label
        ) {
            objRule.commandSetResult.restSyncItem =
                rsiIdsMap[objRule.commandSetResult.restSyncItemId].label;
        }
        // Only one of these 4 could be present for a rule
        // Removed the null values from download file for these
        delete objRule.conceptItemId;
        delete objRule.commandSetResult.conceptItemId;
        delete objRule.rsiId;
        delete objRule.commandSetResult.restSyncItemId;

        return objRule;
    }

    run() {
        let result = [];
        let entityIds = this._activeView.getSelectedPolicyIds();
        let policyName = "";

        if (!_.isEmpty(entityIds)) {
            const promisesList = [];
            promisesList.push(
                this._ConfigAuditPolicyDef.loadConceptItemLabelValues(this._activeOrgId)
            );
            promisesList.push(
                this._ConfigAuditPolicyDef.loadRsiLabelValues(this._activeOrgId, {
                    "Config Modeling Only": {$ne: true},
                })
            );

            promisesList.push(this._commandSetEntityDef.loadCommandSets(this._activeOrgId));
            promisesList.push(this._tagsEntityDef.loadTags(this._activeOrgId));
            return (
                Promise.all(promisesList)
                    .then((values) => {
                        const conceptItems = values[0];
                        const rsiList = values[1];
                        const cmdSets = values[2];
                        const tags = values[3] || [];
                        this._tagIdToNameMap = tags.reduce((acc, tag) => {
                            acc[tag.id] = tag.name;
                            return acc;
                        }, {});

                        let conceptItemsCollection = conceptItems.reduce(
                            (conceptItemsResult, item) => {
                                conceptItemsResult[item.value] = item;
                                return conceptItemsResult;
                            },
                            {}
                        );

                        let rsiIdsMap = rsiList.reduce((acc, item) => {
                            Object.assign(acc, {[item.value]: item});
                            return acc;
                        }, {});
                        let cmdSetValLabelMap = {all: "All"};
                        cmdSets.forEach((cmdSet) => {
                            cmdSetValLabelMap[cmdSet.id] = cmdSet.name;
                        });

                        return Promise.resolve({
                            conceptItemsCollection,
                            rsiIdsMap,
                            cmdSetValLabelMap,
                        });
                    })
                    // this._ConfigAuditPolicyDef
                    //     .loadConceptItemLabelValues(this._activeOrgId)
                    //     .then((conceptItems) => {
                    //         let conceptItemsCollection = conceptItems.reduce((conceptItemsResult, item) => {
                    //             conceptItemsResult[item.value] = item;
                    //             return conceptItemsResult;
                    //         }, {});
                    //         return Promise.resolve(conceptItemsCollection);
                    //     })
                    .then(async ({conceptItemsCollection, rsiIdsMap, cmdSetValLabelMap}) => {
                        let entitiesProm = [];
                        let entities;
                        if (entityIds && entityIds.selectedRows) {
                            entitiesProm = entityIds.selectedRows.map((id) => {
                                return this._ConfigAuditPolicyDef.loadConfigAuditPolicy(
                                    this._activeOrgId,
                                    id
                                );
                            });
                        }
                        entities = await Promise.all(entitiesProm);
                        if (!_.isEmpty(entities)) {
                            entities.forEach((entity) => {
                                result.push(
                                    _.omit(
                                        entity.properties,
                                        "latestHaveIChanged",
                                        "lastAuditBy",
                                        "lastAuditDeviceCount",
                                        "lastAuditDeviceErrorCount",
                                        "lastAuditDeviceSuccessCount",
                                        "lastAuditDevicesInViolationCount",
                                        "lastAuditStatus",
                                        "lastAuditTime",
                                        "lastAuditViolationCount",
                                        "lastAuditCriticalViolationCount",
                                        "lastAuditMajorViolationCount",
                                        "lastAuditMinorViolationCount",
                                        "lastAuditInfoViolationCount",
                                        "lastAuditDevicesNotInViolationCount"
                                    )
                                );
                            });
                        }

                        if (result && !_.isEmpty(result)) {
                            for (let i = 0; i < result.length; i++) {
                                // result.forEach((objResult) => {
                                let objResult = result[i];
                                let rules = _.get(objResult, "rules");
                                rules = await this._CustomFields.templatizeCustomFields(
                                    this._activeOrgId,
                                    rules
                                );
                                objResult.rules = rules;
                                if (!_.isEmpty(rules) && !_.isUndefined(rules)) {
                                    rules.forEach((objRule) => {
                                        objRule.required = objRule.expected;
                                        // objRule.conceptItem = objRule.conceptItemId ? conceptItemsCollection[objRule.conceptItemId].label : null;
                                        // delete objRule.conceptItemId;
                                        delete objRule.expected;
                                        this._processRuleForUUID(
                                            objRule,
                                            rsiIdsMap,
                                            conceptItemsCollection,
                                            cmdSetValLabelMap
                                        );
                                        if (objRule.ifExpression) {
                                            objRule.ifExpression = convertExpressionTags(
                                                objRule.ifExpression,
                                                this._tagIdToNameMap
                                            );
                                        }
                                        return objRule;
                                    });
                                }
                            }
                        }

                        if (entities.length === 1) {
                            policyName = _.get(entities, ["0", "name"], "").trim();
                            policyName = policyName ? policyName + "-" : "";
                        }

                        this._fileFactory.saveJsonAsFile(
                            JSON.stringify(result),
                            this._fileNamer({
                                solution: "CDA",
                                general: "PolicyExport",
                                specific: policyName,
                                suffix: "json",
                            })
                        );

                        return Promise.resolve();
                    })
            );
        }
    }
}
module.exports = ExportAction;

ExportAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "gameEditor.activeView",
    "$teve.entities.ConfigAuditPolicy",
    "$teve.userSession",
    "$teve.io",
    "$teve.entities.CustomFields",
    "$teve.entities.CommandSet",
    "$teve.entities.Tags",
];

ExportAction.$displayDetails = {
    type: "Action",
    name: "ExportAction",
    icon: "configdrift.export_devices",
    shown: true,
    title: "Export policies",
    order: 4,
};
